import { render, staticRenderFns } from "./WurldTextarea.vue?vue&type=template&id=2e1aec4e&"
import script from "./WurldTextarea.vue?vue&type=script&lang=js&"
export * from "./WurldTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WurldTextarea.vue"
export default component.exports